import React, { useState } from "react";
import copy from "copy-to-clipboard";
import { Popup } from "semantic-ui-react";
import {
  Button,
  IconButton,
  withStyles,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Grid,
} from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { generateKey, getAccessKeys } from "../../actions/index";
import { connect } from "react-redux";

const styles = theme => ({
  button: {
    background: "#1e5abb",
    color: "white",
    "&:hover": {
      background: "#3180de",
    },
  },
});

const AccessKeyGenerator = ({
  classes,
  createAccessKey,
  generateKey,
  getAccessKeys,
}) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    getAccessKeys();
    setOpen(false);
  };

  return (
    <>
      <Button
        className={classes.button}
        onClick={() => {
          generateKey();
          setOpen(true);
        }}
      >
        Wygeneruj
      </Button>
      <Dialog
        open={open && createAccessKey}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Klucze dostepu zostały wygenerowane. Zachowaj je w bezpiecznym
          miejscu. <br /> Klucz tajny widoczny będzie tylko raz.
        </DialogTitle>
        <DialogContent>
          <Grid>
            <Grid row>
              <Popup
                content="Skopiowano do schowka"
                on="click"
                position="top left"
                trigger={
                  <IconButton onClick={() => copy(createAccessKey?.apiKey)}>
                    <FileCopyIcon />
                  </IconButton>
                }
              />
              <strong> Klucz API: </strong>
              {createAccessKey?.apiKey}
            </Grid>
            <Grid row>
              <Popup
                content="Skopiowano do schowka"
                on="click"
                position="top left"
                trigger={
                  <IconButton onClick={() => copy(createAccessKey?.secret)}>
                    <FileCopyIcon />
                  </IconButton>
                }
              />
              <strong> Klucz tajny: </strong>
              {createAccessKey?.secret}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapDispatchToProps = { generateKey, getAccessKeys };

const mapStateToProps = ({ createAccessKey }) => ({
  createAccessKey,
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(AccessKeyGenerator)
);
